export default {
  bills: {
    title: 'Monthly Bill Overview',
    balance: 'Current Balance:',
    rechargeNow: 'Recharge Now',
    menu: 'Bill Mgmt',
    statement: 'Billing Records',
    filter: {
      status: 'Status',
      all: 'All',
    },
    table: {
      paymentDays: 'Billing Cycle',
      date: 'Billing Date',
      billAmount: 'Bill Amount',
      paidAmount: 'Paid Amount',
      arrearsAmount: 'Outstanding Amount',
      billDetail: 'Monthly Bill Details',
    },
    status: {
      settled: 'Settled',
      unresolved: 'Unsettled',
      unsettled: 'Unbilled',
      settledTips: 'Settled: Bill issued and paid',
      unresolvedTips: 'Unsettled: Bill issued, not paid',
      unsettledTips: 'Unbilled: Consumed, not billed',
    },
  },
  billDetail: {
    table: {
      date: 'Date',
      scene: 'Scene',
      materialTip:
        'The unit price of creative consumption is controlled by the package and may vary.',
      '3dmodelTip':
        'The unit price for 3D model work orders may also vary, please refer to the 3D model work order list for details.',
      making: {
        '3dmodel': '3D Model Production',
        material: 'Creative Cost',
      },
      objectID: 'Business ID',
      modelQuantity: 'Model Quantity',
      impression: 'Impressions',
      billImpression: 'Billable Impressions',
      cpm: 'Billable CPM',
    },
    options: {
      cap: 'Network Cap',
      allCap: 'All Network Cap',
      buyout: 'Network Buyout',
      allBuyout: 'All Network Buyout',
    },
  },
  statement: {
    search: {
      fingerprint: 'Please Search for Creative Fingerprints',
    },
    table: {
      advDisplayNum: 'Ad Impression',
      advClickNum: 'Ad Click',
      advInstallNum: 'Ad Installation',
      advExpenses: 'Ad Cost',
      chargingNum: 'Billable Ad Impressions',
      materialCosts: 'Creative Cost',
      firstTips: 'When the cost reaches the maximum price,',
      secondTips: 'subsequent impressions are no longer counted for billing.',
    },
  },
  usage: {
    title: 'Usage Details',
    table: {
      date: 'Date',
      usageType: 'Type',
      value: 'Deduction Count',
      unit: 'Unit',
    },
    bizType: {
      aiAsr: 'Speech to Text',
      aiTts: 'Text to Speech',
      aiDvs: 'Intelligent Splitting',
      aigcCredits: 'AI Video',
      voiceClone: 'AI Voice Cloning',
      videos: 'Video Export',
      vrec: 'Screen Recording Tool',
      download: 'Download',
      push: 'Apply',
      aiBanner: 'URL to Image',
      videoOcr: 'Subtitle Recognition',
      avatarVideo: 'Avatar to Video',
      replaceMaterial: 'AI Removal',
      analysisOnly: 'Analyze Video',
      analysisReplace: 'Analyze Video',
      scriptRetain: 'Rewrite Script',
      scriptReplace: 'Generate New Script',
      newAssetNewScript: 'New Script to Assets',
      newAssetOldScript: 'Old Script + Product to Assets',
      videoNewScript: 'Reference to Video',
      videoOriginal: 'Video to Video',
    },
  },
  materials: {
    table: {
      date: 'Push Date',
      project: 'Project Name and ID',
      fingerprint: 'Creative Fingerprint',
      trafficType: 'Apply to',
      totalImpression: 'Total Impressions',
      totalBillImpression: 'Billable Impressions',
      totalServiceFee: 'Cost',
      projectName: 'Project Name',
      billMethod: 'Billing method',
      billMethodNum: 'quantity',
      billNum: 'Billing quantity',
      price: 'Unit price',
      status: 'Billing Status',
      totalAmount: 'Total Creative Cost',
      createdTime: 'Billing Start Date',
      stopTime: 'Billing End Date',
      serviceFee: 'Creative Consumption Cost',
      buyoutPrice: 'Buyout Price',
      maxPrice: 'Price Cap',
      action: 'Operations',
      view: 'Preview',
      download: 'Download',
      buyout: 'Buyout',
      cap: 'Prepay',
    },
    options: {
      charging: 'Billing in Progress',
      endCharge: 'Billing Ended',
    },
    capBuyoutDialog: {
      title: {
        cap: 'Prepay  Creativity Fees',
        buyout: 'Buy Out Creatives',
      },
      tip: {
        cap: 'Do you need to prepay the following creative fees? Once the payment is successful, this creative will no longer incur creative consumption fees. If you prepay for all networks of the creative, other network download permissions for this creative will be automatically unlocked.',
        buyout:
          'Do you need to buy out the following creative? After buyout, the cost of this creative will no longer be counted from the day of the buyout. If all networks are bought out, other network download permissions for this creative will be automatically unlocked.',
      },
      creativeId: 'Creative ID:',
      creativeName: 'Creative Name:',
      trafficType: 'Apply to:',
      price: 'Pending Payment:',
      balance: 'Current Balance:',
      disabledTip:
        'Insufficient available balance, unable to purchase. Please recharge and try again.',
      successful: 'Payment Successful',
      priceTip: {
        cap: 'The amount due is the difference between the price cap and the creative consumption fees already paid.',
        buyout:
          'The total cost of buyouts across multiple networks under the same creative will not exceed the cost of a full network buyout.',
      },
    },
    downloadDialog: {
      editProductInfo: 'Edit Product Info',
      editProductInfoTip:
        'After editing the product information, the assets need to be repackaged, and the process will take some time.',
    },
  },
  balanceThresholdTips:
    'Insufficient balance, function temporarily unavailable. It can be restored after recharging.',
  table: {
    bizType: 'Scenario',
  },
  cost: {
    return: 'Points Refund',
    spend: 'Points Usage',
  },
  status: {
    fail: 'Failed',
  },
}
